import { DocumentsMenuEntry, DocumentsSection, DocumentsSectionsHelper } from '@camelot/files-basic';
import { UPLOADED_DOCUMENTS_KEY } from '@camelot/files-extended';

export type ConversationDocumentsKey = 'communication' | 'task' | 'project' | 'invoice' | 'quotation';

/** documents proposés à la sélection, par origine : une origine sans document n'est pas proposée */
export type ConversationDocumentsPools = Partial<Record<ConversationDocumentsKey, string[]>>;

const CONVERSATION_DOCUMENTS_SECTIONS: DocumentsSection<ConversationDocumentsKey>[] = [
  {
    emptyMessage: 'communication.documents.modal.detail.menu.empty-message.documents.communication',
    key: 'communication',
    label: 'communication.documents.detail.menu.communication',
    order: 2,
  },
  {
    emptyMessage: 'communication.documents.modal.detail.menu.empty-message.documents.task',
    key: 'task',
    label: 'communication.documents.detail.menu.task',
    order: 3,
  },
  {
    emptyMessage: 'communication.documents.modal.detail.menu.empty-message.documents.project',
    key: 'project',
    label: 'communication.documents.detail.menu.project',
    order: 4,
  },
  {
    emptyMessage: 'communication.documents.modal.detail.menu.empty-message.documents.invoice',
    key: 'invoice',
    label: 'communication.documents.detail.menu.invoice',
    order: 5,
  },
  {
    emptyMessage: 'communication.documents.modal.detail.menu.empty-message.documents.quotation',
    key: 'quotation',
    label: 'communication.documents.detail.menu.quotation',
    order: 6,
  },
];

const UPLOADED_DOCUMENTS_ENTRY: DocumentsMenuEntry = {
  defaultOpen: true,
  label: 'communication.documents.detail.menu.' + UPLOADED_DOCUMENTS_KEY,
  order: 1,
};

/** à construire à l'ouverture de la modale : les origines sont connues au moment où l'écran les a chargées */
export const buildConversationSectionsHelper = (pools: ConversationDocumentsPools) =>
  new DocumentsSectionsHelper<ConversationDocumentsKey>(
    CONVERSATION_DOCUMENTS_SECTIONS.filter(section => pools[section.key]?.length),
    [UPLOADED_DOCUMENTS_ENTRY]
  );

export const conversationDocumentsRecord = (
  pools: ConversationDocumentsPools
): Record<ConversationDocumentsKey, string[]> => ({
  communication: pools.communication ?? [],
  invoice: pools.invoice ?? [],
  project: pools.project ?? [],
  quotation: pools.quotation ?? [],
  task: pools.task ?? [],
});
